import { logMessage } from "./amplifyLogger";

export const setAgentStateOffline = (screenName: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!window.connect?.agent || !window.connect?.AgentStateType) {
      reject("Connect Streams not initialized");
      return;
    }
    window.connect.agent((agent: connect.Agent) => {
      const offlineState = agent
        .getAgentStates()
        .find((state: connect.AgentStateDefinition) => {
          return state.type === window.connect.AgentStateType.OFFLINE;
        });
      if (!offlineState) {
        reject("No OFFLINE state available");
        return;
      }
      agent.setState(offlineState, {
        success: () => {
          logMessage(
            screenName,
            `Set agent status to Offline via Streams`,
            `info`,
          );
          resolve("success");
        },
        failure: (err: string) => {
          logMessage(
            screenName,
            `Failed to set agent status to Offline via Streams. ${err}`,
            `error`,
          );
          reject("failure");
        },
      });
    });
  });
};
